import { createContext, useContext } from 'react'

import { UseTransmitReactHook } from '@ally/transmitigator'
import { HostServices, RemoteLogger } from '@ally/federated-types'

export type TransmitContextValues = UseTransmitReactHook & {
  isInPortal?: boolean
  redirects: boolean
  cancelButton?: React.ReactNode
  logger?: RemoteLogger
  // eslint-disable-next-line camelcase
  journey_version?: string
  hostServices?: HostServices
}

export const TransmitContext = createContext<TransmitContextValues>(
  {} as TransmitContextValues,
)

export const useTransmit = (): TransmitContextValues => {
  return useContext(TransmitContext)
}
